/* ============================================================
   Jé Vue cinematic entrance (from the approved JeVueOpening.html)
   Shopify v2: approved entrance with the October 2026 timing changes.
   ============================================================ */
(function () {
'use strict';

/* ---------- Pacing (all times in ms). Adjust here or in the Lab panel. ---------- */
const PACE = {
  // Titles: 4.75 s in total (arrive about 1 s sooner and leave about 1 s sooner than the approved v2; same order and spacing).
  cinematic: { black:500,  wordIn:900,  tagGap:300, tagIn:750,  hold:1050, titlesOut:750,  gap:500,
               eyeIn:1500, eyeHold:600, zoom:2600, reveal:1200 },
  short:     { black:500,  wordIn:1100, tagGap:300, tagIn:900,  hold:1100, titlesOut:900,  gap:250,
               eyeIn:1000, eyeHold:400, zoom:2200, reveal:1000 }
};
// secondHold: seconds WELCOME is held, fully visible, before the scripted second blink.
// afterSecond: seconds the eye rests fully open after the second blink before the entering begins.
// welcomeDelay / welcomeIn: seconds after the first blink reopens, and length of the WELCOME fade (ease-out).
// welcomeMode: 'blink' = placed under the closed lid during the first blink (default); 'fade' = fades on after it.
const SETTINGS = { pace:'cinematic', secondHold:1, afterSecond:0.5, welcomeMode:'blink', welcomeDelay:0, welcomeIn:0.2, forceRM:false, noGL:false, failAssets:false };  // approved values
const ASSET_GRACE = 3000;        // wait this long past the titles for eye files before skipping to the site
const QUICK_EXIT = 700;          // Escape / failure dissolve
const KEY = 'jevue_entered';

/* ---------- WELCOME lettering ---------- */
const WELCOME = {
  text:'WELCOME', cx:628.5, cy:692, size:31, tracking:0.26,          // artwork pixels (1254 grid)
  color:[203,182,147], alpha:0.94,                                  // muted champagne, #cbb693
  font:'"Cormorant Garamond", "Cormorant", Didot, "Bodoni 72", "Times New Roman", serif', weight:500
};
/* Bag geometry measured from the artwork (1254 grid) */
const BAG = { crop:[479,450,777,824], inner:[515,580,742,812], origin:[628.5,696] };

/* ---------- Approved eye artwork and data (byte-for-byte from Jé Vue Blink Study) ---------- */
const ASSETS = (document.getElementById('jv-entrance') || {}).dataset || {};
const IMG = ASSETS.eye;            // assets/jevue-eye.jpg (same bytes as the approved file)
const SHEET = ASSETS.sheet;        // assets/jevue-eye-lid-sheet.jpg (same bytes as the approved file)
// Shopify copy: the eyelid data stays in the approved jevue-entrance.js (unchanged in the theme)
// and is read from it while the titles play, exactly as the House eye already does.
let CURVES='';

/* ---------- Approved blink: constants, shaders and timing copied verbatim ---------- */
const BLINK={close:105,hold:45,open:250};          // ms, real-eye range
const GAP=[2600,6000],DOUBLE_CHANCE=0.14,DOUBLE_GAP=140;
const S=1254;
const VS=`attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}`;
const FS=`precision highp float;
uniform sampler2D uImg,uSheet,uCurve,uWel;uniform float uT,uW;
const float S=1254.,X0=95.,XE=1130.,X1=1192.,F=16.,G=18.,N=220.,B=70.,RISE=22.;
vec3 img(vec2 p){vec2 q=p/S;vec4 w=texture2D(uWel,q);return mix(texture2D(uImg,q).rgb,w.rgb,w.a*uW);}
float h16(float hi,float lo){return (hi*65280.+lo*255.)/32.;}
void main(){
  vec2 p=vec2(gl_FragCoord.x,S-gl_FragCoord.y);
  vec3 o=img(p);
  if(uT<=0.0||p.x<X0||p.x>X1){gl_FragColor=vec4(o,1.);return;}
  float cx=(floor(p.x)+.5)/S;
  vec4 r0=texture2D(uCurve,vec2(cx,.125)),r1=texture2D(uCurve,vec2(cx,.375)),r2=texture2D(uCurve,vec2(cx,.625)),r3=texture2D(uCurve,vec2(cx,.875));
  float u=h16(r0.r,r0.g),l=h16(r0.b,r0.a),k=h16(r1.r,r1.g),dc=h16(r1.b,r1.a),top=h16(r2.r,r2.g),bump=r2.b;
  vec3 gain=r3.rgb*2.55;
  float ring=1.-smoothstep(505.,564.,length(p-vec2(627.)));
  float D=dc*uT*ring;
  float e=u+D;
  vec3 c=o;
  if(p.y>=top&&p.y<e){
    float ext=min(0.3*D,0.55*max(k-top,0.));
    float span=max(k+ext-top,1e-3);
    vec3 st=img(vec2(p.x,top+(p.y-top)*(k-top)/span));
    if(p.y<k+ext){c=st;}
    else{
      vec3 rig=img(vec2(p.x,p.y-D));
      float depth=k+D-p.y;
      float sx=clamp(p.x-X0,0.,1119.);
      vec3 sh=texture2D(uSheet,vec2((sx+.5)/1120.,clamp(30.+depth,0.,599.)/600.)).rgb*gain;
      float fr=clamp(depth/max(D-ext,1.),0.,1.);
      sh*=0.9+0.3*sin(3.14159*fr);
      float w=smoothstep(0.,F,p.y-(k+D));w=mix(1.,w,clamp((D-ext)/F,0.,1.));
      vec3 warped=mix(sh,rig,w);
      c=mix(st,warped,clamp((p.y-(k+ext))/G,0.,1.));
    }
  }else if(p.y>=e&&p.x<=XE){
    float R=RISE*bump*uT*ring,lr=l-R;
    if(p.y>=lr&&p.y<l+N){
      float sy=p.y<lr+B?p.y+R:l+B+(p.y-lr-B)*(N-B)/(N-B+R);
      c=img(vec2(p.x,sy));
    }
    if(p.y<lr+1.){c*=1.-0.3*uT*exp(-(p.y-e)/10.);}
  }
  gl_FragColor=vec4(c,1.);
}`;
const easeInQuad=x=>x*x*(1.6-0.6*x);              // fast, accelerating close
const easeOutCubic=x=>1-Math.pow(1-x,3);         // slower, settling open
function lidAt(ms){
  const {close:a,hold:b,open:c}=BLINK;
  if(ms<0)return 0;
  if(ms<a)return easeInQuad(ms/a);
  if(ms<a+b)return 1;
  if(ms<a+b+c)return 1-easeOutCubic((ms-a-b)/c);
  return 0;
}
const ONE=BLINK.close+BLINK.hold+BLINK.open;

/* ---------- Helpers ---------- */
const $ = (s, r=document) => r.querySelector(s);
const html = document.documentElement;
const ABORT = new Error('jv-abort');
const mq = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches:false };
const reducedMotion = () => SETTINGS.forceRM || mq.matches;
const pace = () => PACE[SETTINGS.pace] || PACE.cinematic;

function seen(){ return window.__jvSeen ? window.__jvSeen() : false; }
function markSeen(){
  try { document.cookie = KEY + '=1; path=/; SameSite=Lax'; } catch (e) {}
  try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
}
function clearSeen(){
  try { document.cookie = KEY + '=; path=/; max-age=0; SameSite=Lax'; } catch (e) {}
  try { sessionStorage.removeItem(KEY); } catch (e) {}
}
function loadImage(src){ return new Promise((res,rej)=>{ if (!src) return rej(new Error('missing asset url')); const i=new Image(); i.crossOrigin='anonymous'; i.onload=()=>res(i); i.onerror=rej; i.src=src; }); }
const easeInOutCubic = x => x<.5 ? 4*x*x*x : 1-Math.pow(-2*x+2,3)/2;
const easeInOutSine  = x => -(Math.cos(Math.PI*x)-1)/2;
const smooth = (a,b,x) => { const t=Math.min(1,Math.max(0,(x-a)/(b-a))); return t*t*(3-2*t); };

/* ============================================================
   WELCOME layer: drawn once into a transparent 1254x1254 texture.
   The shader mixes it into the artwork *before* any eyelid maths,
   so the lids hide it exactly as they hide the handbag.
   ============================================================ */
function drawWelcome(ctx, scale, ox, oy){
  const W = WELCOME, px = W.size*scale;
  ctx.font = W.weight + ' ' + px + 'px ' + W.font;
  ctx.textBaseline = 'middle';
  ctx.fillStyle = 'rgb(' + W.color.join(',') + ')';
  ctx.globalAlpha = W.alpha;
  const track = W.tracking*px, chars = [...W.text];
  const widths = chars.map(c => ctx.measureText(c).width);
  const total = widths.reduce((a,b)=>a+b,0) + track*(chars.length-1);
  let x = (W.cx-ox)*scale - total/2; const y = (W.cy-oy)*scale;
  chars.forEach((c,i)=>{ ctx.fillText(c, x, y); x += widths[i] + track; });
  ctx.globalAlpha = 1;
}
function makeWelcomeTexture(){
  const c = document.createElement('canvas'); c.width = c.height = S;
  const x = c.getContext('2d'); drawWelcome(x, 1, 0, 0);
  // Flat colour + coverage alpha: avoids dark fringes when the texture is filtered.
  const d = x.getImageData(0,0,S,S), p = d.data;
  for (let i=0;i<p.length;i+=4){ p[i]=WELCOME.color[0]; p[i+1]=WELCOME.color[1]; p[i+2]=WELCOME.color[2]; }
  x.putImageData(d,0,0);
  return c;
}

/* ============================================================
   Eye engine: the approved WebGL blink, with a controllable loop.
   ============================================================ */
function createEye(cv, im, sheet, wel, allowGL){
  let gl = null, render, w = 0, lid = 0, lastT = -1, lastW = -1, dead = false, raf = 0;
  if (allowGL) {
    try {
      gl = cv.getContext('webgl',{antialias:false,premultipliedAlpha:false,preserveDrawingBuffer:true});
      if (gl) {
function tex(unit,src,w,h,data,nearest){
  const t=gl.createTexture();gl.activeTexture(gl.TEXTURE0+unit);gl.bindTexture(gl.TEXTURE_2D,t);
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL,false);gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL,false);
  gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL,gl.NONE);
  if(data)gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,w,h,0,gl.RGBA,gl.UNSIGNED_BYTE,data);
  else gl.texImage2D(gl.TEXTURE_2D,0,gl.RGBA,gl.RGBA,gl.UNSIGNED_BYTE,src);
  const f=nearest?gl.NEAREST:gl.LINEAR;
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MIN_FILTER,f);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_MAG_FILTER,f);
  gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_S,gl.CLAMP_TO_EDGE);gl.texParameteri(gl.TEXTURE_2D,gl.TEXTURE_WRAP_T,gl.CLAMP_TO_EDGE);
}
function shader(type,src){const s=gl.createShader(type);gl.shaderSource(s,src);gl.compileShader(s);if(!gl.getShaderParameter(s,gl.COMPILE_STATUS))throw new Error(gl.getShaderInfoLog(s));return s;}
        const pr=gl.createProgram();
        gl.attachShader(pr,shader(gl.VERTEX_SHADER,VS));gl.attachShader(pr,shader(gl.FRAGMENT_SHADER,FS));
        gl.linkProgram(pr);
        if(!gl.getProgramParameter(pr,gl.LINK_STATUS))throw new Error(gl.getProgramInfoLog(pr));
        gl.useProgram(pr);
        gl.bindBuffer(gl.ARRAY_BUFFER,gl.createBuffer());
        gl.bufferData(gl.ARRAY_BUFFER,new Float32Array([-1,-1,1,-1,-1,1,1,1]),gl.STATIC_DRAW);
        const loc=gl.getAttribLocation(pr,'a');gl.enableVertexAttribArray(loc);gl.vertexAttribPointer(loc,2,gl.FLOAT,false,0,0);
        const raw=Uint8Array.from(atob(CURVES),ch=>ch.charCodeAt(0));
        tex(0,im);tex(1,sheet);tex(2,null,S,4,raw,true);tex(3,wel);
        gl.uniform1i(gl.getUniformLocation(pr,'uImg'),0);gl.uniform1i(gl.getUniformLocation(pr,'uSheet'),1);gl.uniform1i(gl.getUniformLocation(pr,'uCurve'),2);
        gl.uniform1i(gl.getUniformLocation(pr,'uWel'),3);
        const uT=gl.getUniformLocation(pr,'uT'), uW=gl.getUniformLocation(pr,'uW');
        gl.viewport(0,0,S,S);
        render=(t,wv)=>{gl.uniform1f(uT,t);gl.uniform1f(uW,wv);gl.drawArrays(gl.TRIANGLE_STRIP,0,4);};
        render(0,0);
        if (gl.getError() !== gl.NO_ERROR || gl.isContextLost()) throw new Error('webgl draw failed');
      }
    } catch (err) { console.warn('[Jé Vue entrance] WebGL unavailable, using still eye.', err); gl = null; }
  }
  if (!gl) {
    // Still-eye fallback: a fresh 2D canvas (a canvas cannot switch context type).
    const c2 = cv.cloneNode(false); cv.replaceWith(c2); cv = c2;
    const x = cv.getContext('2d');
    render = (t,wv)=>{ x.globalAlpha=1; x.drawImage(im,0,0); if (wv>0){ x.globalAlpha=wv; x.drawImage(wel,0,0); x.globalAlpha=1; } };
    render(0,0);
  }

  // Scripted blinks: each one uses the study's own lidAt() curve (same geometry, speed and easing).
  // The entrance now runs exactly two deliberate blinks, so the random gap/double-blink scheduler is not used.
  let blinking=false, blinkStart=0, double=false, onDone=null, onClosed=null, stopReq=false, stopResolve=null;
  function loop(now){
    if (dead) return;
    if (blinking) {
      const ms=now-blinkStart;
      // Lids fully closed (end of the close phase): run the hook before this frame is drawn,
      // so anything it changes is first seen as the lid lifts.
      if (onClosed && ms>=BLINK.close) { const f=onClosed; onClosed=null; f(); }
      let t=double?Math.max(lidAt(ms),lidAt(ms-ONE-DOUBLE_GAP+BLINK.open*0.5)):lidAt(ms);
      const len=double?ONE*2+DOUBLE_GAP-BLINK.open*0.5:ONE;
      let ended=false;
      if (ms>len) { t=0; ended=true; }                       // blink complete, eye fully reopened
      else if (ms<0 && stopReq) { t=0; ended=true; }         // scheduled but not started: cancel
      lid=t;
      if (ended) { blinking=false; if (onDone) { const f=onDone; onDone=null; f(); } }
    }
    if (lid!==lastT || w!==lastW) { render(lid,w); lastT=lid; lastW=w; }
    if (!blinking && stopResolve) { const r=stopResolve; stopResolve=null; r(); }
    raf=requestAnimationFrame(loop);
  }
  raf=requestAnimationFrame(loop);

  return {
    get canvas(){ return cv; },
    get hasGL(){ return !!gl; },
    setWelcome(v){ w=v; },
    /** one complete single blink starting `delay` ms from now; resolves once the eye has fully reopened */
    blinkOnce(delay, whenClosed){
      if (stopReq) return Promise.resolve();
      return new Promise(res=>{ blinking=true; double=false; blinkStart=performance.now()+delay; onDone=res; onClosed=whenClosed||null; });
    },
    /** let a blink in progress finish (or cancel one not yet started), then hold the eye open */
    stopAfterBlink(){
      stopReq=true;
      if (!blinking) { lid=0; return Promise.resolve(); }
      return new Promise(res=>{ stopResolve=res; });
    },
    destroy(){
      dead=true; cancelAnimationFrame(raf);
      if (gl) { try { const e=gl.getExtension('WEBGL_lose_context'); e && e.loseContext(); } catch(e){} }
    }
  };
}

/* ============================================================
   Orchestration
   ============================================================ */
const overlay = $('#jv-entrance');
const TEMPLATE = overlay.innerHTML;          // used to rebuild the overlay for a replay
let R = null;                                // current run state

function lab(stage){ const s=$('#lab-stage'); if (s) s.textContent=stage; if (R) R.stage=stage; }

const locked = [];
function lockSite(on){
  if (on){
    Array.from(document.body.children).forEach(el=>{
      if (el===overlay || /^(SCRIPT|STYLE|LINK|META|TEMPLATE|NOSCRIPT)$/.test(el.tagName) || el.hasAttribute('inert')) return;
      el.setAttribute('inert',''); el.setAttribute('aria-hidden','true'); locked.push(el);
    });
  } else {
    while (locked.length){ const el=locked.pop(); el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
  }
}

function start(){
  if (R) teardown();
  overlay.innerHTML = TEMPLATE;
  overlay.hidden = false; overlay.style.opacity = '';
  html.classList.add('jv-entrance');
  lockSite(true);
  const ctrl = new AbortController();
  R = { ctrl, signal:ctrl.signal, ready:false, entering:false, eye:null, timers:[], anims:[], t0:performance.now(), stage:'' };
  try { overlay.focus({preventScroll:true}); } catch(e){}
  const P = pace(), rm = reducedMotion();
  const total = P.black+P.wordIn+P.tagGap+P.tagIn+P.hold+P.titlesOut+P.gap+P.eyeIn+P.eyeHold+ONE+(SETTINGS.welcomeDelay+SETTINGS.welcomeIn)*1000
              + (SETTINGS.secondHold+SETTINGS.afterSecond)*1000 + ONE + P.zoom + P.reveal + ASSET_GRACE + 6000;
  R.watchdog = setTimeout(()=>{ console.warn('[Jé Vue entrance] watchdog'); quickExit(); }, total);
  run(R).catch(err=>{ if (err!==ABORT){ console.error('[Jé Vue entrance]', err); quickExit(); } });
}

function sleep(ms){
  const r=R; return new Promise((res,rej)=>{
    if (r.signal.aborted) return rej(ABORT);
    const id=setTimeout(res,ms); r.timers.push(id);
    r.signal.addEventListener('abort',()=>{ clearTimeout(id); rej(ABORT); },{once:true});
  });
}
function fade(el, from, to, ms, easing){
  const r=R, a=el.animate([{opacity:from},{opacity:to}],{duration:Math.max(1,ms),easing:easing||'cubic-bezier(.45,0,.25,1)',fill:'forwards'});
  r.anims.push(a);
  return new Promise((res,rej)=>{
    a.onfinish=()=>res(); a.oncancel=()=>rej(ABORT);
    r.signal.addEventListener('abort',()=>{ try{a.cancel();}catch(e){} },{once:true});
  });
}
function tween(ms, fn, ease){
  const r=R; return new Promise((res,rej)=>{
    const t0=performance.now();
    (function step(now){
      if (r.signal.aborted) return rej(ABORT);
      const p=Math.min(1,(now-t0)/ms); fn(ease?ease(p):p, p);
      if (p<1) requestAnimationFrame(step); else res();
    })(t0);
  });
}
function withTimeout(promise, ms){
  return Promise.race([promise, new Promise((_,rej)=>{ const id=setTimeout(()=>rej(new Error('timeout')),ms); R.timers.push(id); })]);
}

async function loadAssets(){
  if (SETTINGS.failAssets) throw new Error('simulated asset failure');
  const fontReady = (document.fonts && document.fonts.load)
    ? Promise.race([document.fonts.load(WELCOME.weight+' 40px "Cormorant Garamond"'), new Promise(r=>setTimeout(r,2500))]).catch(()=>{})
    : Promise.resolve();
  const curvesReady = CURVES ? Promise.resolve() : fetch(ASSETS.curves, { credentials:'omit' }).then(r=>r.text())
    .then(t=>{ CURVES = (t.match(/["'`](W0BbQFtA[A-Za-z0-9+\/=]{1000,})["'`]/) || [])[1] || ''; })
    .catch(e=>console.warn('[Jé Vue entrance] eyelid data could not load; the eye will show still.', e));
  const [im, sheet] = await Promise.all([loadImage(IMG), loadImage(SHEET), fontReady, curvesReady]);
  return { im, sheet, wel: makeWelcomeTexture() };
}

async function run(r){
  const P = pace(), rm = reducedMotion();
  const F = ms => rm ? Math.min(ms, 600) : ms;          // reduced motion: gentle, shorter fades
  const titles=$('.jv-titles',overlay), word=$('.jv-wordmark',overlay), tag=$('.jv-tagline',overlay);
  const stage=$('.jv-stage',overlay), hit=$('.jv-hit',overlay), live=$('#jv-live',overlay);

  // If the wordmark image can't load, fall back to set type rather than an empty frame.
  let wordEl = word;
  const swapWord = ()=>{ const t=document.createElement('p'); t.className='jv-wordmark-fallback'; t.textContent='Jé Vue'; word.replaceWith(t); wordEl=t; };
  if (word.complete && word.naturalWidth===0) swapWord(); else word.addEventListener('error', swapWord, {once:true});

  const assets = loadAssets();                 // eye files load during the titles
  assets.catch(()=>{});

  // ---- Stage 1: cinematic titles ----
  lab('Black'); await sleep(P.black);
  lab('Wordmark'); await fade(wordEl, 0, 1, F(P.wordIn));
  await sleep(P.tagGap);
  lab('Tagline'); await fade(tag, 0, 1, F(P.tagIn));
  lab('Titles hold'); await sleep(P.hold);
  lab('Titles out'); await fade(titles, 1, 0, F(P.titlesOut));
  await sleep(P.gap);

  // ---- Stage 2: the eye ----
  let a;
  try { a = await withTimeout(assets, ASSET_GRACE); }
  catch (e) { console.warn('[Jé Vue entrance] eye files not ready, going to the site.', e); lab('Assets failed → site'); return quickExit(); }
  const eye = r.eye = createEye($('.jv-eye',overlay), a.im, a.sheet, a.wel, !SETTINGS.noGL);
  prepareZoomLayer();
  lab(eye.hasGL ? 'Eye in' : 'Eye in (still image)');
  await fade(stage, 0, 1, F(P.eyeIn));
  const blinks = !rm && eye.hasGL;
  hit.addEventListener('click', ()=>enter('bag'));
  if (blinks && SETTINGS.welcomeMode==='blink') {
    // ---- Stage 3: WELCOME is placed on the bag while the lids are fully closed,
    //      so the first blink opens onto it, as if it had always been there ----
    lab('First blink');
    await eye.blinkOnce(P.eyeHold, ()=>{ eye.setWelcome(1); lab('First blink · WELCOME placed under the lid'); });
    lab('WELCOME');
  } else {
    if (blinks) { lab('First blink'); await eye.blinkOnce(P.eyeHold); }
    else { await sleep(P.eyeHold); }
    // ---- Stage 3 (alternative / still eye): WELCOME fades on after the eye reopens ----
    await sleep(SETTINGS.welcomeDelay*1000);
    lab('WELCOME');
    await tween(F(Math.max(100, SETTINGS.welcomeIn*1000)), v=>eye.setWelcome(v), x=>1-Math.pow(1-x,3));
  }
  r.ready = true;
  hit.disabled = false;
  live.textContent = 'Welcome. Select the handbag, or press Enter, to enter the house.';

  // ---- Stage 4 (automatic): hold, scripted second blink, then enter ----
  lab('WELCOME hold');
  await sleep(SETTINGS.secondHold*1000);
  if (r.entering) return;
  if (blinks) { lab('Second blink'); await eye.blinkOnce(0); }
  if (r.entering) return;
  lab('Rest after second blink'); await sleep(SETTINGS.afterSecond*1000);
  if (r.entering) return;
  enter('auto');
}

/* Bag layer for the enlargement: the original handbag pixels (alpha-masked)
   plus WELCOME redrawn at higher resolution in exactly the same position. */
function prepareZoomLayer(){
  const zc = $('.jv-zoom-welcome', overlay), stage = $('.jv-stage', overlay);
  const [x0,y0,x1,y1] = BAG.crop, cw = x1-x0, ch = y1-y0;
  const cssW = stage.getBoundingClientRect().width * cw / S;
  const k = Math.min(8, Math.max(2, (cssW*(window.devicePixelRatio||1)*2)/cw));
  zc.width = Math.round(cw*k); zc.height = Math.round(ch*k);
  drawWelcome(zc.getContext('2d'), k, x0, y0);
  // Black silhouette of the bag (same mask) to sit over the original bag in the eye once it lifts off.
  const under = $('.jv-under', overlay), bagImg = $('.jv-zoom > img', overlay);
  const paint = ()=>{ under.width = cw; under.height = ch; const u = under.getContext('2d');
    u.drawImage(bagImg, 0, 0, cw, ch); u.globalCompositeOperation = 'source-in'; u.fillStyle = '#000'; u.fillRect(0, 0, cw, ch); };
  if (bagImg.complete && bagImg.naturalWidth) paint(); else bagImg.addEventListener('load', paint, {once:true});
}

async function enter(source){
  const r = R;
  if (!r || !r.ready || r.entering) return;
  r.entering = true;
  markSeen();
  const hit=$('.jv-hit',overlay); hit.disabled = true; hit.blur();
  lab(source==='auto' ? 'Auto entrance' : 'Entering');
  try {
    await r.eye.stopAfterBlink();                    // any blink in progress finishes naturally
    if (reducedMotion()) { await fade(overlay, 1, 0, 700); return finish(); }
    await zoom(r);
    lab('Reveal');
    await fade(overlay, 1, 0, pace().reveal, 'cubic-bezier(.4,0,.2,1)');
    finish();
  } catch (e) { if (e!==ABORT){ console.error(e); quickExit(); } }
}

function zoom(r){
  const P = pace();
  const stage=$('.jv-stage',overlay), layer=$('.jv-zoom',overlay), eyeCv=r.eye.canvas;
  const zw=$('.jv-zoom-welcome',overlay);
  const sr = stage.getBoundingClientRect(), k = sr.width / S;
  const vw = innerWidth, vh = innerHeight;
  const [ix0,iy0,ix1,iy1] = BAG.inner;
  // scale at which the bag's black interior covers the whole viewport (with margin)
  const sEnd = Math.max(vw/((ix1-ix0)*k), vh/((iy1-iy0)*k)) * 1.18;
  // move the interior's centre to the viewport centre as it grows
  const ox = sr.left + BAG.origin[0]*k, oy = sr.top + BAG.origin[1]*k;
  const dx = vw/2 - ox, dy = vh/2 - oy;
  const under=$('.jv-under',overlay);
  layer.style.visibility = 'visible';              // pixel-identical swap onto the still, open eye
  under.style.visibility = 'visible';              // the original bag position now reads as dark pupil
  r.eye.setWelcome(0);                             // WELCOME now lives on the bag layer
  const lnS = Math.log(sEnd);
  lab('Handbag enlarges');
  return tween(P.zoom, (e, p)=>{
    const sc = Math.exp(lnS*e);
    const m = easeInOutSine(p);
    layer.style.transform = `translate(${dx*m}px, ${dy*m}px) scale(${sc})`;
    zw.style.opacity = String(1 - smooth(1.3, 1.95, sc));     // WELCOME fades as the bag passes the iris
    const eo = String(1 - smooth(1.6, 3.6, sc));               // eye artwork fades as the bag passes the eye
    eyeCv.style.opacity = eo; under.style.opacity = eo;
  }, easeInOutCubic);
}

function finish(){
  if (!R) return;
  lab('Entered');
  clearTimeout(R.watchdog);
  const eye=R.eye; R.ctrl.abort(); R.timers.forEach(clearTimeout); eye && eye.destroy();
  R = null;
  overlay.hidden = true;
  html.classList.remove('jv-entrance');
  lockSite(false);
  const main = $('#MainContent');
  if (main){ try { if (!main.hasAttribute('tabindex')){ main.setAttribute('tabindex','-1'); main.setAttribute('data-jv-focus','');
    main.addEventListener('blur', ()=>{ main.removeAttribute('tabindex'); main.removeAttribute('data-jv-focus'); }, {once:true}); }
    main.focus({preventScroll:true}); } catch(e){} }
}
function quickExit(){
  if (!R || R.exiting) return;
  R.exiting = true; markSeen();
  const r=R; r.ctrl.abort(); r.timers.forEach(clearTimeout);
  const a = overlay.animate([{opacity:getComputedStyle(overlay).opacity},{opacity:0}],{duration:QUICK_EXIT,easing:'ease',fill:'forwards'});
  a.onfinish = ()=>{ if (R===r) finish(); };
  setTimeout(()=>{ if (R===r) finish(); }, QUICK_EXIT+400);
}
function teardown(){
  const r=R; if (!r) return;
  clearTimeout(r.watchdog); r.ctrl.abort(); r.timers.forEach(clearTimeout);
  r.anims.forEach(a=>{ try{a.cancel();}catch(e){} }); r.eye && r.eye.destroy();
  overlay.getAnimations && overlay.getAnimations().forEach(a=>a.cancel());
  R=null;
}

/* Keyboard: Enter/Space enters once WELCOME is shown; Escape goes straight to the site. */
document.addEventListener('keydown', e=>{
  if (!R) return;
  if (e.key==='Escape'){ e.preventDefault(); if (!R.entering) quickExit(); return; }
  if ((e.key==='Enter' || e.key===' ') && R.ready && !R.entering && !e.target.closest('#jv-lab')){ e.preventDefault(); enter('key'); }
  if (e.key==='Tab' && !e.target.closest('#jv-lab')){            // keep focus inside the entrance
    const hit=$('.jv-hit',overlay);
    if (hit && !hit.disabled){ e.preventDefault(); hit.focus(); }
    else { e.preventDefault(); overlay.focus(); }
  }
});

/* ---------- Go ---------- */
if (html.classList.contains('jv-entrance')) {
  start();
} else {
  overlay.hidden = true;
}
})();
